// Utility to check if a date+time is in the past
export function isPastDateTime(date, time) {
  const now = new Date();
  const slotDateTime = new Date(`${date}T${time}`);
  return slotDateTime < now;
}

const VILNIUS_TZ = 'Europe/Vilnius';

const vilniusPartsFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: VILNIUS_TZ,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false
});

function getVilniusLocalParts(date) {
  const parts = vilniusPartsFormatter.formatToParts(date);
  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
  return {
    year: parseInt(map.year, 10),
    month: parseInt(map.month, 10),
    day: parseInt(map.day, 10),
    hour: parseInt(map.hour, 10),
    minute: parseInt(map.minute, 10),
    second: parseInt(map.second, 10)
  };
}

/**
 * Convert Europe/Vilnius local date-time to UTC Date.
 * Uses iterative correction so DST transition days resolve correctly.
 */
function zonedDateTimeToUTCDate(year, month, day, hour, minute) {
  const targetLocalMs = Date.UTC(year, month - 1, day, hour, minute, 0);
  let guessUtcMs = targetLocalMs;

  for (let i = 0; i < 4; i += 1) {
    const local = getVilniusLocalParts(new Date(guessUtcMs));
    const guessedLocalMs = Date.UTC(
      local.year,
      local.month - 1,
      local.day,
      local.hour,
      local.minute,
      local.second || 0
    );
    const diffMs = targetLocalMs - guessedLocalMs;
    if (Math.abs(diffMs) < 1000) break;
    guessUtcMs += diffMs;
  }

  return new Date(guessUtcMs);
}

/** Parse date+time as Europe/Vilnius and return a Date (UTC). */
export function vilniusToDate(dateStr, timeStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  const time = (timeStr || '00:00').slice(0, 5);
  const [hh, mm] = time.split(':').map((x) => parseInt(x, 10) || 0);
  return zonedDateTimeToUTCDate(y, m, d, hh, mm);
}

/** Build Google Calendar URL dates param (UTC) from Lithuania local time. */
export function vilniusToCalendarUTC(dateStr, startTime, durationMinutes) {
  const start = vilniusToDate(dateStr, startTime);
  const end = new Date(start.getTime() + (durationMinutes || 60) * 60000);
  const pad = (n) => String(n).padStart(2, '0');
  const toIso = (d) =>
    `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`;
  return `${toIso(start)}/${toIso(end)}`;
} 